<template>
    <div id="name-modal" class="text-center">
        <div>
            <button type="button" class="close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6 class="mt-3 mb-3 ml-2 mr-2">{{heading}}</h6>
        </div>
        <div class="form-group">
            <input v-model="localName" style="width: 90%; margin: 0 auto;" class="form-control" type="text">
        </div>
        <div>
            <button @click="updateCategory" class="btn btn-primary btn-block">OK</button>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'NameModal',
    data(){
      return {
        localName: ''
      }
    },
    props: ['name', 'heading', 'categoryId', 'type'],
    created(){
      this.localName = this.name;
    },
    methods: {
      updateCategory () {
        this.$emit('updateCategoryName', {name: this.localName, id: this.categoryId, type: this.type})
        this.$emit('close')
      },
      closeModal () {
        this.$emit('close')
      },
    }
  }
</script>

<style scoped>
    .close {
        margin-right: 10px;
        margin-top: -5px;
    }
</style>